<template>
  <div class="vbody">
    <span v-for="(info, index) in publication_list" :key="index" v-show="Check_Has_Name(index)">
      <div class="time_divide" v-if="info['type'] == 'time'" v-show="Check_Time_Title_Has_Children(index)">
        {{ info["time"] }}
      </div>

      <div class="news_item" v-if="info['type'] == 'news'">
        <div class="item_left">
          <div class="item_point_J" v-if="info['source'] == '0'">J</div>
          <div class="item_point_M" v-if="info['source'] == '1'">C</div>
        </div>
        <div class="item_text">
          <div class="item_text_chara">{{ info["chara"] }}</div>
          <div class="item_text_title_text">
            {{ info["title"] }}
          </div>
          <div class="item_link">
            <a v-if="Check_Display(info['href_text'])" v-bind:href="info['href_text']">[Full Text]</a>
            <a v-if="Check_Display(info['pjt'])">[Project Homepage]</a>
            <a v-if="Check_Display(info['href_code'])" v-bind:href="info['href_code']">[Code]</a>
          </div>
          <div class="item_text_journal">{{ info["Journal"] }}</div>
        </div>
      </div>
    </span>
  </div>
</template>

<script>
// import $ from "jquery";
import {loadFile} from "../Utils/m_utils"
export default {
  name: "vPublication",
  props: ["msg"],
  data() {
    return {
      publication_list: [],
    };
  },
  mounted() {


    //const that = this;
    // $.getJSON("/data/publication.json", function (data) {
    //   that.publication_list = data;
    //   console.log(data);
    // });
    
    this.publication_list = JSON.parse(loadFile("/data/publication.json?v="+Math.random()));
  },
  methods: {
    Check_Display(item) {
      //通过字符串检查是否显示链接信息，字符串为空白或未定义则不显示
      if (item == "") {
        return false;
      }
      if (typeof item == "undefined") {
        return false;
      }
      return true;
    },
    

    Check_Has_Name(index) {
      //检查作者信息里是否包含几种人名的缩写
      console.log(index);
      return true;
      //let chara_str = this.publication_list[index]["chara"];
      //let type_str = this.publication_list[index]["type"];
      //if (type_str == "time") {
      //  return true;
      //}
//
      //if (chara_str == undefined) {
      //  return false;
      //}
      //// console.log(this.msg);
      //for (let i = 0; i < this.msg["chara_name_list"].length; i++) {
      //  if (chara_str.indexOf(this.msg["chara_name_list"][i]) != -1) {
      //    return true;
      //  }
      //}
//
      //return false;
    },
    Check_Time_Title_Has_Children(index) {
      let type_str = this.publication_list[index]["type"];
      if (type_str != "time") {
        console.log("Check_Time_Title_Has_Children函数参数错误");
      }

      for (let i = index + 1; i < this.publication_list.length; i++) {
        if (this.publication_list[i]["type"] == "time") {
          break;//到达了下一个时间项目，停止
        }
        if (this.Check_Has_Name(i)) {
          return true;
        }
      }
      return false;
    }
  },
};
</script>

<style scoped>
.vbody {
  text-align: left;
  /* background-color: #00701c; */
}

.time_divide {
  color: grey;
  font-family: Verdana;
  font-size: 16pt;
  text-align: left;
  margin-bottom: 30px;
}

.item_left {
  display: inline-block;
  /* background-color: red; */
  width: 50px;
  height: 50px;
  vertical-align: top;
  text-align: center;
}

.item_text {
  display: inline-block;
  /* background-color: blueviolet; */
  width: 90%;
  max-width: 1300px;
  min-height: 80px;
  vertical-align: top;
}

.item_text>div {
  height: 24px;
}

.item_text>a {
  font-family: Poppins;
  font-size: 12pt;
}

.item_text_chara {
  font-family: Poppins;
  font-size: 12pt;
  color: #111;
  display: inline-block;
  width: 80vw;
}

.item_text_title_text {
  font-family: Poppins;
  font-size: 12pt;
  color: #000;
  font-weight: bold;
  display: inline-block;

}

.item_link {
  font-family: Poppins;
  font-size: 12pt;
  display: inline-block;
  width: 100px;
  height: 100px;
}

.item_text_journal {

  font-family: Poppins;
  font-size: 12pt;
  color: #111;
  display: inline-block;
  /* background-color: aqua; */
  /* line-height: 12pt; */
  width: 80vw;
}

.news_box {
  /* background-color: rgba(0, 255, 0, 0.1); */
  width: 1200px;
  min-height: 500px;
  display: inline-block;
  text-align: left;
}

.item_point_J {
  background-color: #00701c;
  height: 20px;
  width: 20px;
  border-radius: 4px;
  border: solid;
  border-color: #00701c;
  display: inline-block;
  color: white;
  font-weight: 800;
  line-height: 13px;
  font-size: 20px;
  padding-top: 6px;
  /* font-family: Arial, Helvetica, sans-serif; */
  font-family: "Merriweather", Georgia, "Times New Roman", Times, serif;
}

.item_point_M {
  background-color: #a7a400;
  height: 20px;
  width: 20px;
  border-radius: 4px;
  border: solid;
  border-color: #a7a400;
  display: inline-block;
  color: white;
  font-weight: 800;
  line-height: 13px;
  font-size: 20px;
  padding-top: 6px;
  font-family: "Merriweather", Georgia, "Times New Roman", Times, serif;
}

.news_item {
  /* background-color: greenyellow; */
  /* min-height: 80px; */
  width: 90%;
  /* display: inline-block; */
  text-align: left;
  /* margin-left: -100px; */
  /* display: inline-block; */
}
</style>